function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "StatusIcon_To_Engage_",
  transform: "translate(-14 -19.794)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5758",
  transform: "translate(14 19.794)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61243",
  d: "M5.114,11.176c0,3.762,3.146,7.471,8.06,10.635a1.939,1.939,0,0,0,.817.334,1.854,1.854,0,0,0,.817-.334c4.913-3.164,8.06-6.873,8.06-10.635A5.141,5.141,0,0,0,17.762,5.7a4.437,4.437,0,0,0-3.77,1.934A4.424,4.424,0,0,0,10.221,5.7,5.146,5.146,0,0,0,5.114,11.176Z",
  transform: "translate(11.886 18.094)",
  fill: "currentColor"
}));

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a00606fa.svg";
export { ForwardRef as ReactComponent };